// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tY","tag":"tZ","isRental":"t0","title":"t1","title2":"t2","description":"t3","cta":"t4","ratingLabel":"t5","ratingLabelSmallScreen":"t6","iconInHotspotVideo":"t7"};